import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="disable-collapsed-inputs"
export default class extends Controller {
  connect() {
    this.onHide = this.disableInputs.bind(this)
    this.onShow = this.enableInputs.bind(this)

    this.element.addEventListener("hide.bs.collapse", this.onHide)
    this.element.addEventListener("show.bs.collapse", this.onShow)

    // Initial check - if using fieldset with disabled=true in HTML, this might be redundant but safe.
    // If not using fieldset, we need to ensure inputs are disabled if hidden.
    if (!this.element.classList.contains("show")) {
      this.disableInputs()
    }
  }

  disconnect() {
    if (this.onHide) {
      this.element.removeEventListener("hide.bs.collapse", this.onHide)
    }

    if (this.onShow) {
      this.element.removeEventListener("show.bs.collapse", this.onShow)
    }
  }

  disableInputs() {
    if (this.fieldset) {
      this.fieldset.disabled = true
    } else {
      this.inputs.forEach(input => input.disabled = true)
    }
  }

  enableInputs() {
    if (this.fieldset) {
      this.fieldset.disabled = false
    } else {
      this.inputs.forEach(input => input.disabled = false)
    }
  }

  get fieldset() {
    return this.element.querySelector("fieldset")
  }

  get inputs() {
    return this.element.querySelectorAll("input, select, textarea")
  }
}
